module.exports = __webpack_public_path__ + "img/Feature.f80bf520.png";